<template>
  <div class="container">
    <div class="block">
      <div class="content-inner-wrapper">
        <div class="content-header">
          <template v-if="status === 0">
            <h3>订单详情</h3>
            <van-form label-width="1.1rem">
              <van-field name="orderNum" label="订单编号：">
                <template #input>
                  {{ orderId }}
                </template>
              </van-field>
              <van-field name="orderCont" label="订单内容：">
                <template #input> {{ title }}云服（{{ txt }}） </template>
              </van-field>
              <van-field name="count" label="购买数量：">
                <template #input>
                  {{ count }}
                </template>
              </van-field>
              <van-field class="buyTime" name="buyTime" label="购买时长：">
                <template #input>
                  {{ day }}天<em v-show="subMoney"
                    >（原价¥{{ oriMoney }}，限时折扣价¥{{ money }}）</em
                  >
                </template>
              </van-field>
              <van-field name="createTime" label="创建时间：">
                <template #input>
                  {{ createTime | formatTime }}
                </template>
              </van-field>
              <van-field class="totalItem" name="totalMoney" label="合计金额：">
                <template #input>
                  ¥{{ money
                  }}<em v-show="subMoney">（已优惠¥{{ subMoney }}）</em>
                </template>
              </van-field>
            </van-form>
            <h3>支付方式</h3>
            <van-radio-group v-model="payType">
              <van-cell-group>
                <van-cell title="支付宝支付" clickable @click="payType = '4'">
                  <template #icon>
                    <img
                      src="../../images/common/alipay.svg"
                      class="icon-pay"
                    />
                  </template>
                  <template #right-icon>
                    <van-radio name="4" type="primary" />
                  </template>
                </van-cell>
                <van-cell title="微信支付" clickable @click="payType = '3'">
                  <template #icon>
                    <img
                      src="../../images/common/wechatpay.svg"
                      class="icon-pay"
                    />
                  </template>
                  <template #right-icon>
                    <van-radio name="3" type="primary" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
            <van-button class="confirmPay" @click="getCode"
              >确认支付</van-button
            >
          </template>
          <template v-else-if="status === 1">
            <div class="paySuccess">
              <van-icon name="checked" />
              <h3>支付成功</h3>
              <p>
                请前往云服列表页查看及管理您的云服，设置游戏备份请前往迷你世界客户端
              </p>
              <a @click="$router.push({ name: 'cloudServerOrderList' })"
                >点击可查看订单>></a
              >
              <van-button
                class="backBtn"
                @click="$router.push({ name: 'cloudServerManager' })"
                >返回主页</van-button
              >
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { cloudApi } from '../../api/index';
import mixins from '../../mixins/pay.mixins';
const { getPayCode, getPayState } = cloudApi;
export default {
  mixins: [mixins],
  data() {
    return {
      sunBuyType: 2,
    };
  },
  created() {
    let urlQueryArr = location.href.split('?');
    if (urlQueryArr.length > 1) {
      urlQueryArr = urlQueryArr[1];
      const paramsArr = urlQueryArr.split('&');
      const params = {};
      paramsArr.forEach(function (val) {
        const tmp = val.split('=');
        params[tmp[0]] = tmp[1];
      });
      const backId = params.out_trade_no || params.id || 0;
      if (backId) {
        getPayState({ id: backId }).then(res => {
          if (res.code === 0 && res.data.state === 2) {
            this.status = 1;
          }
        });
      }
    }
    const cacheInfo = JSON.parse(localStorage.getItem('payInfo'));
    if (cacheInfo && cacheInfo.paying && this.status !== 1) {
      this.$dialog
        .confirm({
          title: '支付提示',
          message: '微信支付中，请等待支付完成..',
          confirmButtonText: '已支付完成',
        })
        .then(() => {
          // 点击了已支付完成
          getPayState({ id: cacheInfo.id }).then(res => {
            if (res.code === 0 && res.data.state === 2) {
              this.status = 1;
            }
          });
        });
    }
  },
  methods: {
    getCode() {
      getPayCode({
        buy_type: this.payType,
        id: this.orderId,
        sub_buy_type: this.sunBuyType,
      }).then(res => {
        if (res.code === 0) {
          const { data } = res;
          const { pay_url: payUrl } = data;
          const jumpLink = payUrl;
          console.log('getPayCode res ----', jumpLink);
          if (this.payType === '3') {
            this.$dialog
              .confirm({
                title: '支付提示',
                message: '跳转至微信支付，请等待支付完成..',
                confirmButtonText: '已支付完成',
              })
              .then(() => {
                // 点击了已支付完成
                getPayState({ id: this.orderId }).then(res => {
                  if (res.code === 0 && res.data.state === 2) {
                    this.status = 1;
                  } else {
                    this.$toast.fail(res.msg);
                  }
                });
              });
            const orgParams = JSON.parse(localStorage.getItem('payInfo'));
            orgParams.payType = this.payType;
            orgParams.paying = true;
            localStorage.setItem('payInfo', JSON.stringify(orgParams));
            localStorage.setItem('lastJumpLink', jumpLink);
            location.href = jumpLink;
          } else {
            location.href = jumpLink;
          }
        }
      });
    },
  },
};
</script>
<style src="../../style/common-m.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
h3 {
  margin-bottom: 32px;
}
.van-form {
  margin-bottom: 44px;
}
.van-cell-group {
  &::after {
    display: none;
  }
}
.van-cell {
  padding: 20px 0;
  .icon-pay {
    width: 80px;
    height: 80px;
    margin-right: 24px;
  }
  .van-cell__title {
    display: flex;
    align-items: center;
    span {
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #595959;
      line-height: 56px;
    }
  }
  ::v-deep .van-radio {
    .van-radio__icon--checked {
      .van-icon.van-icon-success {
        background-color: #fd9b21;
        border-color: #fd9b21;
      }
    }
  }
}
.van-field {
  padding: 0;
  height: auto;
  line-height: 56px;
  margin-bottom: 8px;
  font-size: 32px;
  color: #262626;
  ::v-deep .van-field__control {
    white-space: nowrap;
    flex-wrap: wrap;
  }
  &::after {
    display: none;
  }
}
.buyTime {
  ::v-deep .van-cell__value {
    .van-field__control {
      em {
        font-weight: 400;
        font-style: normal;
        font-size: 24px;
      }
    }
  }
}
.totalItem {
  margin-top: 16px;
  ::v-deep .van-cell__value {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 56px;
    .van-field__control {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      color: #ff4433;
      em {
        font-weight: 400;
        font-style: normal;
        font-size: 24px;
      }
    }
  }
}
.confirmPay {
  display: block;
  margin: 200px auto 0;
  width: 646px;
  height: 88px;
  background: #fecb4e;
  border-radius: 16px;
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3d3c3c;
  line-height: 40px;
}
.paySuccess {
  .van-icon.van-icon-checked {
    display: block;
    width: 152px;
    height: 152px;
    color: #42db99;
    font-size: 152px;
    margin: 282px auto 32px;
  }
  h3 {
    font-size: 48px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262626;
    line-height: 66px;
    text-align: center;
    margin: 0 auto 64px;
  }
  p {
    margin: 0 auto;
    text-align: center;
    width: 614px;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8c8c8c;
    line-height: 44px;
  }
  a {
    display: block;
    width: 264px;
    height: 44px;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3b9aff;
    line-height: 44px;
    margin: 20px auto 20px;
    text-align: center;
  }
  .backBtn {
    display: block;
    border-color: #fecb4e;
    width: 646px;
    height: 88px;
    background: #fecb4e;
    border-radius: 16px;
    font-size: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3d3c3c;
    line-height: 40px;
    margin: 278px auto 0;
  }
}
</style>
